import { useEffect, useState } from 'react';
import styles from './index.module.scss';

const Prize = function(props) {
  const [py, setPY] = useState(0)
  useEffect(() => {
    const target = `${props.target}`
    if(target.indexOf('init') > -1 || props.target < 0) {
      setPY(-124 * target.replace(/\D/g, ''))
    } else {
      const delay = 400 * props.index
      setTimeout(() => {
        const start = (py % 868 + 868) % 868
        const end = -124 * target.replace(/\D/g, '') - 868 * (2 + props.index)
        const duration = (5 + props.index * props.index) * 300
        ani(start, end, setPY, Math.floor(16 * (start - end ) / duration))
      }, delay)
    }
  }, [props.target])
  return (
    <div style={{ backgroundPositionY: props.target < 0 ? '' : py + 'px' }} className={[styles.prize, props.className].join('\x20')}></div>
  )
}

function ani(curr, target, func, speed) {
  func(curr)
  setTimeout(() => {
    if(curr > target) {
      const nextNum = curr - speed
      ani(nextNum < target ? target : nextNum, target, func, speed)
    }
  }, 16)
}

export default Prize;
